import {
  getConfigurationsData,
  getByIdConfigurations,
  editByIdConfigurations,
  getPaymentGatewayConfigsData,
  getEventactionMappingData,
  getEventActionTemplate,
  editEventActionmapping,
  getEnumData,
  viewEnumData,
  createEnum,
  deleteEnumById,
  createConfiguration,
  editByIdPaymentGatwayConfigs, updateConfigurationFlag,
  updatePaymentgatewayConfigurationFlag,
  updateHooksFlag,
  createEventActionmapping, editSubmitEventAction,
} from "@/http/system/configuration.js";

export default {
  namespaced: true,
  state: {
    configurationsData: [],
    ByIdConfigurationsData: [],
    editIdConfigurationsData: [],
    paymentGatewayConfigsData: [],
    eventactionMappingData: [],
    editEventAction: [],
    enumConfig: [],
    viewEnumConfig: {},
  },
  actions: {
    async setConfigurationsList({ commit }) {
      try {
        const resp = await getConfigurationsData();
        commit("SET_CONFIGURATIONS_LIST", resp.data.globalConfiguration);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setByIdConfigurationsList({ commit }, payload) {
      try {
        const resp = await getByIdConfigurations(payload);
        commit("SET_CONFIGURATIONID_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setEditByIdConfigurationsList({ commit }, payload) {
      try {
        const resp = await editByIdConfigurations(payload);
        commit("SET_EDITCONFIGURATIONID_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPaymentGatewayConfigsList({ commit }) {
      try {
        const resp = await getPaymentGatewayConfigsData();
        commit("SET_PAYMENTGATEWAY_LIST", resp.data.globalConfiguration);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setEventactionMappingList({ commit }) {
      const resp = await getEventactionMappingData();
      resp.data = resp.data.map((x) => {
        x.isDeletedBool = x.isDeleted === "N" ? true : false;
        return x;
      });
      commit("SET_EVENTACTIONMAPPING_LIST", resp.data);
      return resp;
    },
    async getCreateSetEventActionTemplate({ commit }, data) {
      try {
        return await getEventActionTemplate(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setEditEventAction({ commit }, data) {
      try {
        const resp = await editEventActionmapping(data);
        // commit("SET_EDITEVENTACTION_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createConfigurationAction({ commit }, data) {
      try {
        const resp = await createConfiguration(data);

        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchEnumList({ commit }) {
      try {
        const res = await getEnumData();
        commit("SET_ENUM_LIST", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteEnumByIdAction({ commit }, data) {
      try {
        await deleteEnumById(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async fetchViewEnumData({ commit }, payload) {
      try {
        let res = await viewEnumData(payload);
        commit("VIEW_ENUM_DATA", res.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createEnumAction({ commit }, payload) {
      try {
        const resp = await createEnum(payload);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setEditByIdPaymentConfig({ commit }, payload) {
      try {
        const resp = await editByIdPaymentGatwayConfigs(payload);

        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateConfigurationFlagAction({ commit }, payload) {
      try {
        const resp = await updateConfigurationFlag(payload.id, payload.data);

        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updatePaymentgatewayConfigurationFlagAction({ commit }, payload) {
      try {
        const resp = await updatePaymentgatewayConfigurationFlag(payload.id, payload.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateHooksFlagAction({ commit }, id) {
      try {
        const resp = await updateHooksFlag(id);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createEventActionmappingAction({ commit }, payload) {
      try {
        const resp = await createEventActionmapping(payload);

        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editSubmitEventActionAction({ commit }, payload) {
      try {
        const resp = await editSubmitEventAction(payload.id, payload.data);

        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
          `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_CONFIGURATIONS_LIST(state, payload) {
      state.configurationsData = payload;
    },
    SET_CONFIGURATIONID_LIST(state, payload) {
      state.ByIdConfigurationsData = payload;
    },
    SET_EDITCONFIGURATIONID_LIST(state, payload) {
      state.editIdConfigurationsData = payload;
    },
    SET_PAYMENTGATEWAY_LIST(state, payload) {
      state.paymentGatewayConfigsData = payload;
    },
    SET_EVENTACTIONMAPPING_LIST(state, payload) {
      state.eventactionMappingData = payload;
    },
    SET_ENUM_LIST(state, payload) {
      state.enumConfig = payload;
    },
    VIEW_ENUM_DATA(state, payload) {
      state.viewEnumConfig = payload;
    },
  },
  getters: {
    getConfigurationsList(state) {
      return state.configurationsData;
    },
    getByIdConfigurationsDataList(state) {
      return state.ByIdConfigurationsData;
    },
    geteditIdConfigurationsList(state) {
      return state.editIdConfigurationsData;
    },
    getPaymentGatewayConfigsList(state) {
      return state.paymentGatewayConfigsData;
    },
    getEventactionMappingList(state) {
      return state.eventactionMappingData;
    },
    getEditEventActionData(state) {
      return state.editEventAction;
    },
  },
};
